<div class="row">
    <div class='col-sm-12'>
        <div style='padding:1.0em;'>
            <div class="pull-right">
                <div class='inline' style='margin-left:0.5em;' *ngIf="courseVendor.zoom.id">
                    <app-open-button-sm (click)="openZoom()">Zoom</app-open-button-sm>
                </div>
                <div class='inline' style='margin-left:0.5em;' *ngIf="courseVendor.joinUrl">
                    <app-presentation-button [isActive]="true" (click)="open(courseVendor.joinUrl)">Join</app-presentation-button>
                </div>
            </div>
            
            <div *ngIf="vendor.logo" style='margin-bottom:1.0em;'>
                <img class="file-preview" [src]="vendor.logo">
            </div>
            
            <div style='font-size:1.2em;'>{{vendor.name}}</div>

            <div style='font-size:0.9em;margin-top:0.5em;'>
                <div style="margin-top:0.5em;" *ngIf="vendor.description">{{vendor.description}}</div>
            </div>
            
            <div class="clearfix"></div>

            <div *ngIf="courseVendor.videoUrl" style='font-size:0.9em;margin-top:0.5em;'>
                <div class="group-title" style='margin-top:2.0em;'>Video</div>
                
                <div style="margin-top:0.5em;">
                    <a [attr.href]="courseVendor.videoUrl" target="_blank">{{courseVendor.videoUrl}}</a>
                </div>
            </div>

            <div style='font-size:0.9em;margin-top:0.5em;'>
                <div *ngIf="vendor.address || vendor.email || vendor.phone || vendor.website">
                    <div class="group-title" style='margin-top:2.0em;'>Contact Information</div>
                    
                    <div style="margin-top:0.5em;" *ngIf="vendor.address">
                        <div>{{vendor.address}}</div>
                        <div>{{vendor.city}}, {{vendor.state}} {{vendor.zip}}</div>
                    </div>
                    <div style="margin-top:0.5em;" *ngIf="vendor.email">{{vendor.email}}</div>
                    <div style="margin-top:0.5em;" *ngIf="vendor.phone">
                        {{ vendor.phone | slice:0:3 }} {{ vendor.phone | slice:3:6 }} {{ vendor.phone | slice:6:10 }}
                    </div>
                    <div style="margin-top:0.5em;" *ngIf="vendor.website">
                        <a [attr.href]="vendor.website" target="_blank">{{vendor.website}}</a>
                    </div>
                </div>
                
                <div *ngIf="vendor.twitter || vendor.facebook || vendor.youtube">
                    <div class="group-title" style='margin-top:2.0em;'>Social</div>
                    
                    <div>
                        <div class='inline' style="margin-top:0.5em;" *ngIf="vendor.twitter">
                            <app-social-button [type]="'twitter'" [value]="vendor.twitter"></app-social-button>
                        </div>
                        <div class='inline' style="margin-top:0.5em;" *ngIf="vendor.facebook">
                            <app-social-button [type]="'facebook'" [value]="vendor.facebook"></app-social-button>
                        </div>
                        <div class='inline' style="margin-top:0.5em;" *ngIf="vendor.youtube">
                            <app-social-button [type]="'youtube'" [value]="vendor.youtube"></app-social-button>
                        </div>
                    </div>
                </div>

                <div *ngIf="courseVendor.docebo && courseVendor.docebo.showOpen">
                    <div class="group-title" style='margin-top:2.0em;'>Additional Materials</div>
                    
                    <div style='margin-top:1.0em;' *ngIf="courseVendor.docebo.id">
                        <app-open-button-sm (click)="openDocebo()">Access Additional Materials</app-open-button-sm>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div><pre>{{courseVendor | json}}</pre></div> -->
        <!-- <div><pre>{{vendor | json}}</pre></div> -->
    </div>
</div>

<div class='row' *ngIf='loadingError'>
    <div class='col-sm-12 text-center error'>
        <div>{{loadingError}}</div>
    </div>
</div>